module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSIjMjMyRDMwIj48cGF0aCBkPSJNOS4wMi41MzZsMS40MTUgMS40MTQtOC40ODUgOC40ODVMLjUzNiA5LjAyMXoiLz48cGF0aCBkPSJNMTAuNDM1IDkuMDJsLTEuNDE0IDEuNDE1TC41MzYgMS45NSAxLjk1LjUzNnoiLz48L2c+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/dismiss.svg
// module id = 988
// module chunks = 168707334958949